// 新建案件弹窗翻译配置 - 简体中文
export default {
  dialog: {
    title: "新建案件",
  },
  form: {
    labels: {
      name: "案件名称",
      caseType: "案件类型",
      description: "案件说明",
    },
    placeholders: {
      name: "请输入案件名称(必填)",
      caseType: "请选择案件类型(必填)",
      description: "请输入案件说明",
    },
    rules: {
      nameRequired: "案件名称为必填项",
      nameLength: "长度在 1 到 20个字符",
      caseTypeRequired: "请选择案件类型",
      descriptionLength: "长度在 1 到 200个字符",
    },
  },
  buttons: {
    cancel: "取消",
    create: "新建",
  },
  messages: {
    createSuccess: "新建成功",
  },
};
